import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import { useDispatch, useSelector } from 'react-redux';
import { TrashIcon } from '../../../../assets/svg/iconos';
import { PeriodSelect } from '../descansos/PeriodSelect';
import { openModalBottom } from '../../../../actions/ui';

const timezone = process.env.REACT_APP_TIMEZONE;

const diasBtns = [
    { _id: '1', nombre: 'Lunes', abr: 'Lu', active: false },
    { _id: '2', nombre: 'Martes', abr: 'Ma', active: false },
    { _id: '3', nombre: 'Miércoles', abr: 'Mi', active: false },
    { _id: '4', nombre: 'Jueves', abr: 'Ju', active: false },
    { _id: '5', nombre: 'Viernes', abr: 'Vi', active: false },
    { _id: '6', nombre: 'Sábado', abr: 'Sa', active: false },
    { _id: '7', nombre: 'Domingo', abr: 'Do', active: false }
];

export const HorarioExtraItem = ({ editMode, horarioExtra, editHorarioExtra, deleteHorarioExtra, horariosExtraTemp, objProfesional, descansosTemp = [], empresa }) => {

    const dispatch = useDispatch();
    const { colores } = useSelector( state => state.ui );

    const [diasSemana, setDiasSemana] = useState(horarioExtra.diasSemana || []);

    useEffect(() => {
        setDiasSemana( horarioExtra.diasSemana || [] );
    }, [horarioExtra]);

    useEffect(() => {
        const newHorarioExtra = { 
            ...horarioExtra,
            diasSemana,
            repetir: diasSemana.length > 0
        };

        editHorarioExtra(newHorarioExtra);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [diasSemana]);

    const clickRepeat = (id) => {
        if( editMode ){
            let newArray = [];
            if( diasSemana.includes(id) ){
                newArray = diasSemana.filter( item => item !== id );
            } else {
                newArray = [ ...diasSemana, id ];
            }
            newArray.sort((a, b) => { 
                return a - b; 
            })
            setDiasSemana( newArray );
        }
    }

    const haySolapamiento = (horario1, horario2) => {
        if (horario1._id === horario2._id) return false;

        const fechaInicio1 = moment.tz(horario1.fechaInicio, timezone);
        const fechaFin1 = moment.tz(horario1.fechaFin, timezone);
        const fechaInicio2 = moment.tz(horario2.fechaInicio, timezone);
        const fechaFin2 = moment.tz(horario2.fechaFin, timezone);

        const rangosFechasSolapan = fechaInicio1.isSameOrBefore(fechaFin2) && fechaFin1.isSameOrAfter(fechaInicio2);
        if (!rangosFechasSolapan) return false;

        if (horario1.repetir && horario2.repetir) {
            const diasComunes = horario1.diasSemana.filter(dia => horario2.diasSemana.includes(dia));
            if (diasComunes.length === 0) return false;
        } else if (horario1.repetir || horario2.repetir) {
            if (horario1.repetir) {
                const diaSemana2 = moment.tz(horario2.fechaInicio, timezone).isoWeekday().toString();
                if (!horario1.diasSemana.includes(diaSemana2)) return false;
            } else {
                const diaSemana1 = moment.tz(horario1.fechaInicio, timezone).isoWeekday().toString();
                if (!horario2.diasSemana.includes(diaSemana1)) return false;
            }
        }

        if (horario1.todaJornada || horario2.todaJornada) {
            return true;
        }

        const horaInicio1 = horario1.horaInicio ? moment.tz(horario1.horaInicio, timezone) : null;
        const horaFin1 = horario1.horaFin ? moment.tz(horario1.horaFin, timezone) : null;
        const horaInicio2 = horario2.horaInicio ? moment.tz(horario2.horaInicio, timezone) : null;
        const horaFin2 = horario2.horaFin ? moment.tz(horario2.horaFin, timezone) : null;

        if (!horaInicio1 || !horaFin1 || !horaInicio2 || !horaFin2) return true;

        const hora1Inicio = horaInicio1.hours() * 60 + horaInicio1.minutes();
        const hora1Fin = horaFin1.hours() * 60 + horaFin1.minutes();
        const hora2Inicio = horaInicio2.hours() * 60 + horaInicio2.minutes();
        const hora2Fin = horaFin2.hours() * 60 + horaFin2.minutes();

        return (hora1Inicio < hora2Fin && hora1Fin > hora2Inicio);
    };

    const saveChanges = ( horaInicio, horaFin ) => {
        if (moment(horaFin).isBefore(moment(horaInicio))) {
            dispatch(openModalBottom({ 
                text: ['La fecha/hora de fin debe ser posterior a la fecha/hora de inicio'], 
                timeOut: 3 
            }));
            return;
        }

        const fechaInicio = moment(horaInicio).startOf('day');
        const fechaFin = moment(horaFin).startOf('day');
        const mismoDia = fechaInicio.isSame(fechaFin, 'day');
        
        if (mismoDia) {
            const horaInicioMoment = moment(horaInicio);
            const horaFinMoment = moment(horaFin);
            if (horaFinMoment.isSameOrBefore(horaInicioMoment)) {
                dispatch(openModalBottom({ 
                    text: ['La hora de fin debe ser posterior a la hora de inicio'], 
                    timeOut: 3 
                }));
                return;
            }
        }

        let newHorarioExtra = { 
            ...horarioExtra,
            fechaInicio: moment.tz( horaInicio, timezone ).toISOString(),
            fechaFin: moment.tz( horaFin, timezone ).toISOString(),
            todaJornada: false,
            horaInicio: moment.tz( horaInicio, timezone ).toISOString(),
            horaFin: moment.tz( horaFin, timezone ).toISOString(),
        };

        if (horariosExtraTemp && horariosExtraTemp.length > 0) {
            const haySolap = horariosExtraTemp.some(he => haySolapamiento(newHorarioExtra, he));
            if (haySolap) {
                dispatch(openModalBottom({ 
                    text: ['Este horario extra se solapa con otro horario extra existente'], 
                    timeOut: 3 
                }));
                return;
            }
        }

        editHorarioExtra( newHorarioExtra );
    }


    return (
        <div className='horario-extra-item'>
            <div className='item-period'>
                <div className='item-header'>Disponibilidad</div>
                <div className='item-content'>
                    <PeriodSelect
                        editMode={ editMode }
                        descanso = { { ...horarioExtra, tipo: 'horario_extra' } }
                        saveChanges = { saveChanges }
                        objProfesional={ objProfesional }
                    />
                </div>
            </div>
            <div className='item-repeat-borrar'>
                <div className='item-repeat'>
                    <div className='item-header'>Repetición</div>
                    <div className='item-content' style={{ flexDirection: 'column', alignItems: 'flex-start', height: 'auto' }}>
                        <div className='repeat-selector'>
                            {
                                diasBtns.map( dia => (
                                    <div 
                                        key={ `dia${ dia._id }`} 
                                        className={`repeat-item ${ diasSemana.includes(dia._id) ? 'active' : ''}`}
                                        style={{ 
                                            borderColor: colores.colorPrincipal,
                                        }}
                                        onClick={ () => clickRepeat(dia._id)}
                                    >
                                        { dia.abr }
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <div 
                        className='item-borrar'
                        onClick={ () => deleteHorarioExtra( horarioExtra ) }
                    >
                        <TrashIcon />
                    </div>
                </div>
            </div>
        </div>
    )
}

